import http from './http'

export default class LabelPrintAPI {
  /**
   * 获取预支类型内容
   * @param {object} params - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static gerPresetType(params) {
    return http.get({
      url: `/base/bluetoothCustomPrintTemplate/contentItems/selections`,
      params,
    })
  }
  /**
   * 获取商户类型
   * @since 1.0.0
   * @param {object} params - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static getTenantType(params = {}) {
    return http.get({
      url: `/base/bluetoothCustomPrintTemplate/contentItems/getTenantType`,
      params,
    })
  }

  /**
   * 获取水洗标图片列表
   * @since 1.0.0
   * @param {object} data - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static getWashingMarkList(data = {}) {
    return http.post({
      url: `/base/bluetoothCustomPrintTemplate/contentItems/getGraphItems`,
      data,
    })
  }
  /**
   * 保存水洗标图片
   * @since 1.0.0
   * @param {object} data - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static saveWashingMark(data = {}) {
    return http.post({
      url: `/base/bluetoothCustomPrintTemplate/contentItems/saveGraphItem`,
      data,
    })
  }

  /**
   * 删除水洗标图片
   * @since 1.0.0
   * @param {object} id - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static deleteWashingMark(id = '') {
    return http.delete({
      url: `/base/bluetoothCustomPrintTemplate/contentItems/delete/${id}`,
    })
  }

  /**
   * 保存标签详情
   *
   * @since 1.0.0
   * @param {object} data - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static save(data = {}) {
    return http.post({
      url: `/base/bluetoothCustomPrintTemplate/saveTemplate`,
      data,
    })
  }

  /**
   * 获取标签详情
   * @since 1.0.0
   * @param {object} options - http 请求参数
   * @returns {Promise} - 返回操作后的 Promise
   */
  static getDetail(id) {
    return http.get({
      url: `/base/bluetoothCustomPrintTemplate/detail/${id}`,
    })
  }
}
